document.addEventListener('DOMContentLoaded', function () {
    const goTopBtn = document.querySelector('.go-to-top');
    if (goTopBtn) {
        goTopBtn.addEventListener('click', function (e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
});